import React from 'react';
import { editorialTeamPropTypes } from './EditorialTeamPropTypes';
import Tooltip from '@Theme/natucare/components/Tooltip/Tooltip';
import AuthorDetails from '@Theme/natucare/components/Tooltip/modules/AuthorDetails/AuthorDetails';
import Author from './components/Author/Author';
import * as styles from './EditorialTeam.module.scss';
const EditorialTeam = ({
  editorialTeam
}) => {
  if (!editorialTeam) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, editorialTeam === null || editorialTeam === void 0 ? void 0 : editorialTeam.map((author, index) => author.details ? /*#__PURE__*/React.createElement(Tooltip, {
    trigger: /*#__PURE__*/React.createElement(Author, author),
    key: index
  }, /*#__PURE__*/React.createElement(AuthorDetails, author)) : /*#__PURE__*/React.createElement(Author, Object.assign({}, author, {
    key: index
  }))));
};
export default EditorialTeam;